import { useCodeSelector } from '@dtx-company/inter-app/src/hooks/useCodeSelector'

// hooks related to fetching state required to display experiments

export const useShowProUpsellExperiment = (): boolean => {
  return useCodeSelector(state => state.homePage.showProUpsellExperiment)
}
